import React from "react";
//outsource
import { Row, Col, Radio } from "antd";
import { REQUEST_OPTIONS } from "../../../store/string";
//components

const RequestFilter = ({ handleChange }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Radio.Group
      defaultValue={"All"}
      optionType="button"
      buttonStyle="solid"
      options={REQUEST_OPTIONS}
      onChange={handleChange}
    />
  );
};

export default RequestFilter;
